export default {
  getData (state) {
    return state.data
  },
  getPermissions (state) {
    return state.data.permissions || {}
  },
  getTableColumns (state) {
    return state.data.tableColumns || []
  },
  getFields (state) {
    return state.data.fields || []
  },
  getDefaultValues (state) {
    return state.data.defaultValues || {}
  },
  getLinks (state) {
    return state.data.links || []
  },
  getIsDataLoaded (state) {
    return state.isDataLoaded
  }
}